import styled from '@emotion/styled';

export const FormContainer = styled('form')`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 400px;
`;
